import { DivWithLoadingBackground } from "./ImageLoaders";
import { insertTextbeforeUrlExtention } from "../utils/general/text-formatting.js";
import { b_roll_urls } from "../utils/config/image-links.js";

export default function Lighthouse() {
  return (
    <div className="flex lg:flex-row flex-col gap-4 xl:px-[20%] px-[10%] bg-white py-10 border-y border-black items-center justify-center text-center">
      <div className="flex flex-col gap-4 lg:w-[60%] w-full">
        <h1 className="md:text-2xl text-xl font-bold">Supporting The Lighthouse Club</h1>
        <p className="md:text-lg text-base">
          All proceeds from our events go to our Charity of the Year, The Lighthouse Club – the only charity dedicated to providing emotional, physical, and financial wellbeing support to construction workers and their families.
        </p>
        <p className="md:text-lg text-base">
          Every year, thousands of workers in the industry face serious injuries, long-term health issues, and mental health challenges. The Lighthouse Club offers 24/7 helplines, on-site wellbeing support, and financial assistance to those in need, ensuring that no one in the construction industry must face hardship alone.
        </p> 
        <a href="https://www.lighthouseclub.org/" className="text-blue-500">More on Lighthouse Charity</a>
      </div>

      <div className="border border-gray-200 rounded-lg overflow-hidden lg:w-[40%] w-112 border border-black">
      <DivWithLoadingBackground 
        imageUrl={insertTextbeforeUrlExtention(b_roll_urls[21], "_tinyres")} 
        className="flex w-full h-60 bg-cover bg-center"
      />
    </div>
  </div>
);
}   